import { useShipFromValidation } from '../../../../ship-from/components/ship-from-dropdown/validator';

export const ShipFromValidator = ({ children, selectedShipFromId, shipFroms, selectedCarrierId }) => {
  const validation = useShipFromValidation({
    selectedShipFromId,
    shipFroms,
    selectedCarrierId,
  });

  return children({ validation });
};
